import small from "../images/small.webp";
import smalls from "../images/small_s.webp";
import medium from "../images/medium.webp";
import mediums from "../images/medium_s.webp";
import large from "../images/large.webp";
import larges from "../images/large_s.webp";

import MVP from "../images/mvp.webp";
import MVPs from "../images/mvp_s.webp";
import Basic from "../images/basic.webp";
import Basics from "../images/basic_s.webp";
import polished from "../images/polished.webp";
import polisheds from "../images/polished_s.webp";

import email from "../images/email.webp";
import emails from "../images/email_s.webp";
import fb from "../images/email.webp";
import fbs from "../images/fb_s.webp";
import twitter from "../images/twitter.webp";
import twitters from "../images/twitter_s.webp";
import google from "../images/google.webp";
import googles from "../images/google_s.webp";
import linkedin from "../images/linkedin.webp";
import linkedins from "../images/linkedin_s.webp";
import github from "../images/github.webp";
import githubs from "../images/github_s.webp";
import invite from "../images/invite.webp";
import invites from "../images/invite_s.webp";
import multi from "../images/multi.webp";
import multis from "../images/multi_s.webp";
import domain from "../images/domain.webp";
import domains from "../images/domain_s.webp";

import dashboard from"../images/dashboard.webp";
import dashboards from"../images/dashboard_s.webp";
import activity from"../images/activity.webp";
import activitys from"../images/activity_s.webp";
import media from"../images/media.webp";
import medias from"../images/media_s.webp";
import profile from"../images/profile.webp"
import profiles from"../images/profile_s.webp";
import temail from"../images/temail.webp";
import temails from"../images/temail_s.webp";
import tags from"../images/tags.webp";
import tagss from"../images/tags_s.webp";
import rating from"../images/rating.webp";
import ratings from"../images/rating_s.webp";
import media_edit from"../images/media_edit.webp";
import media_edits from"../images/media_edit_s.webp";
import search from"../images/search.webp";
import searchs from"../images/search_s.webp";

import calendar from"../images/calendar.webp";
import calendars from"../images/calendar_s.webp";
import map from"../images/map.webp";
import maps from"../images/map_s.webp";
import geo from"../images/geo.webp";
import geos from"../images/geo_s.webp";
import booking from"../images/booking.webp";
import bookings from"../images/booking_s.webp";

import msg from"../images/msg.webp";
import msgs from"../images/msg_s.webp";
import forum from"../images/forum.webp";
import forums from"../images/forum_s.webp";
import social from"../images/social.webp";
import socials from"../images/social_s.webp";
import push_fb from"../images/push_fb.webp";
import push_fbs from"../images/push_fb_s.webp";
import push from"../images/push.webp";
import pushs from"../images/push_s.webp";

import card from"../images/card.webp";
import cards from"../images/card_s.webp";
import shopping from"../images/shopping.webp";
import shoppings from"../images/shopping_s.webp";
import market from"../images/market.webp";
import markets from"../images/market_s.webp";
import in_app from"../images/in-app.webp";
import in_apps from"../images/in-app_s.webp";
import pay_info from"../images/pay_info.webp";
import pay_infos from"../images/pay_info_s.webp";
import pay_proc from"../images/pay_proc.webp";
import pay_procs from"../images/pay_proc_s.webp";
import prod_m from"../images/prod_m.webp";
import prod_ms from"../images/prod_m_s.webp";

import cms from"../images/cms.webp";
import cmss from"../images/cms_s.webp";
import admin from"../images/admin.webp";
import admins from"../images/admin_s.webp";
import support from"../images/support.webp";
import supports from"../images/support_s.webp";
import analytics from"../images/analytics.webp";
import analyticss from"../images/analytics_s.webp";
import warn from"../images/warn.webp";
import warns from"../images/warn_s.webp";
import perf from"../images/perf.webp";
import perfs from"../images/perf_s.webp";
import multi_lang from"../images/multi_lang.webp";
import multi_langs from"../images/multi_lang_s.webp";

import party from"../images/3_party.webp";
import partys from"../images/3_party_s.webp";
import api from"../images/api.webp";
import apis from"../images/api_s.webp";
import sms from"../images/sms.webp";
import smss from"../images/sms_s.webp";
import phone from"../images/phone.webp";
import phones from"../images/phone_s.webp";

import ssl from"../images/ssl.webp";
import ssls from"../images/ssl_s.webp";
import ddos from"../images/ddos.webp";
import ddoss from"../images/ddos_s.webp";
import security from"../images/security.webp";
import securitys from"../images/security_s.webp";

import dev from"../images/dev.webp";
import devs from"../images/dev_s.webp";
import pm from"../images/pm.webp";
import pms from"../images/pm_s.webp";
import selected from "../images/selected.webp"
import nonselect from "../images/nonselect.webp"
import selectone from "../images/selectedone.webp"

const imageData = {
  selectone,
  nonselect,
  selected,
    small,
    smalls,
    medium,
    mediums,
    large,
    larges,
    MVP,
    MVPs,
    Basic,
    Basics,
    polished,
    polisheds,
    email,
    emails,
    fb,
    fbs,
    twitter,
    twitters,
    google,
    googles,
    linkedin,
    linkedins,
    github,
    githubs,
    invite,
    invites,
    multi,
    multis,
    domain,
    domains,
    dashboard,
    dashboards,
    activity,
    activitys,
    media,
    medias,
    profile,
    profiles,
    temail,
    temails,
    tags,
    tagss,
    rating,
    ratings,
    in_apps,
    in_app,
    media_edit,
    media_edits,
    search,
    searchs,
    calendar,
    calendars,
    map,
    maps,
    geo,
    geos,
    booking,
    bookings,
    msg,
    msgs,
    forum,
    forums,
    social,
    socials,
    push_fb,
    push_fbs,
    push,
    pushs,
    card,
    cards,
    shopping,
    shoppings,
    market,
    markets,
    pay_info,
    pay_infos,
    pay_proc,
    pay_procs,
    prod_m,
    prod_ms,
    cms,
    cmss,
    admin,
    admins,
    support,
    supports,
    analytics,
    analyticss,
    warn,
    warns,
    perf,
    perfs,
    multi_lang,
    multi_langs,
    party,
    partys,
    api,
    apis,
    sms,
    smss,
    phone,
    phones,
    ssl,
    ssls,
    ddos,
    ddoss,
    security,
    securitys,
    dev,
    devs,
    pm,
    pms,
};
  
  export default imageData;
  

